function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68 120C96.7188 120 120 96.7188 120 68C120 39.2812 96.7188 16 68 16C39.2812 16 16 39.2812 16 68C16 96.7188 39.2812 120 68 120ZM68 136C105.555 136 136 105.555 136 68C136 30.4446 105.555 0 68 0C30.4446 0 0 30.4446 0 68C0 105.555 30.4446 136 68 136Z",
  fill: "url(#paint0_linear_10278_3835)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.6 68C121.6 97.6025 97.6025 121.6 68 121.6C38.3975 121.6 14.4 97.6025 14.4 68C14.4 38.3975 38.3975 14.4 68 14.4C97.6025 14.4 121.6 38.3975 121.6 68ZM68 134.4C104.672 134.4 134.4 104.672 134.4 68C134.4 31.3283 104.672 1.6 68 1.6C31.3283 1.6 1.6 31.3283 1.6 68C1.6 104.672 31.3283 134.4 68 134.4ZM120 68C120 96.7188 96.7188 120 68 120C39.2812 120 16 96.7188 16 68C16 39.2812 39.2812 16 68 16C96.7188 16 120 39.2812 120 68ZM136 68C136 105.555 105.555 136 68 136C30.4446 136 0 105.555 0 68C0 30.4446 30.4446 0 68 0C105.555 0 136 30.4446 136 68Z",
  fill: "url(#paint1_linear_10278_3835)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 60C12.4183 60 16 63.5817 16 68C16 96.7188 39.2812 120 68 120V136C30.4446 136 0 105.555 0 68C0 63.5817 3.58172 60 8 60Z",
  fill: "url(#paint2_linear_10278_3835)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_10278_3835",
  x1: 7.00001,
  y1: 64,
  x2: 68,
  y2: 127.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2F5F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_10278_3835",
  x1: 100.5,
  y1: 127.5,
  x2: -0.00000101492,
  y2: 53.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBEFF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEFF2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_10278_3835",
  x1: 8,
  y1: 68,
  x2: 57.5,
  y2: 128,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0D53FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgLoadingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading_icon.76b832e6.svg";
export { ForwardRef as ReactComponent };